module.exports = __webpack_public_path__ + "media/src/application/media/animation/title1-9d4a7af39d9b85287fb90e5429825137.svg";